// Local dev: keep VITE_DIGISAKA_API_ORIGIN empty in .env — Vite proxies /api (see vite.config.ts).
// Production build: set VITE_DIGISAKA_API_ORIGIN=https://backend.digisaka.com before `npm run build`.
const rawOrigin = import.meta.env.VITE_DIGISAKA_API_ORIGIN;

export const DIGISAKA_API_ORIGIN: string =
  rawOrigin !== undefined && String(rawOrigin).trim() !== ''
    ? String(rawOrigin).replace(/\/$/, '')
    : import.meta.env.DEV
      ? ''
      : 'https://backend.digisaka.com';
